export default __webpack_public_path__ + "static/staff-office-f4a948492e979e0a2d69d35236fc1f12.jpg";